module.exports = __webpack_public_path__ + "static/media/about.d027ae8a.jpeg";